<template>
  <form @submit.prevent="submit">
    <b-row>
      <b-col sm="12">
        <b-form-group label="Exportadora">
          <b-form-select
            id="client"
            @change="getCompanies()"
            :state="$v.waybillData.client_customer.$dirty ? !$v.waybillData.client_customer.$error : null"
            v-model="$v.waybillData.client_customer.$model"
            :options="customers"
          >
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="6">
        <b-form-group label="Emisor">
          <v-select
            :options="companies"
            label="text"
            :state="$v.waybillData.company.$dirty ? !$v.waybillData.company.$error : null"
            v-model="$v.waybillData.company.$model"
            :reduce="(text) => text.value"
            class="style-chooser"
          >
          </v-select>
        </b-form-group>

        <b-form-group label="Destinatario">
          <v-select
            :options="companies"
            label="text"
            :state="$v.waybillData.recipient.$dirty ? !$v.waybillData.recipient.$error : null"
            v-model="$v.waybillData.recipient.$model"
            :reduce="(text) => text.value"
            class="style-chooser"
          >
          </v-select>
        </b-form-group>

        <b-form-group>
          <label for="name">Nombre del Chofer</label>
          <b-form-input
            type="text"
            id="name"
            :state="$v.waybillData.truck_driver.$dirty ? !$v.waybillData.truck_driver.$error : null"
            v-model="$v.waybillData.truck_driver.$model"
            placeholder="ej. Juan Soto"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <!--Column 2-->
      <b-col sm="6">
        <b-form-group>
          <label for="waybill_number">Número de guía de despacho</label>
          <b-form-input
            type="text"
            id="waybill_number"
            :state="$v.waybillData.number.$dirty ? !$v.waybillData.number.$error : null"
            v-model="$v.waybillData.number.$model"
            placeholder="ej. 1234"
          ></b-form-input>
        </b-form-group>

        <b-form-group>
          <label for="waybill_date">Fecha de guía de despacho</label>
          <b-form-input
            type="date"
            id="waybill_date"
            :state="$v.waybillData.waybill_date.$dirty ? !$v.waybillData.waybill_date.$error : null"
            v-model="$v.waybillData.waybill_date.$model"
          ></b-form-input>
        </b-form-group>

        <b-form-group>
          <label for="name">Patente</label>
          <b-form-input
            type="text"
            id="name"
            :state="$v.waybillData.license_plate.$dirty ? !$v.waybillData.license_plate.$error : null"
            v-model="$v.waybillData.license_plate.$model"
            placeholder="ej. FL9090"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group>
          <label for="textarea-auto-height">Notas:</label>
          <b-form-textarea
            id="textarea"
            v-model="waybillData.note"
            placeholder="Escriba acá notas relacionadas con la guia de despacho."
            rows="3"
            max-rows="6"
          >
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { required, numeric, minLength, between } from "vuelidate/lib/validators";

export default {
  name: "FormWaybill",
  components: {
    vSelect
  },
  props: ["waybillData"],
  data() {
    return {
      customers: [{ value: "", text: "Cargando..." }],
      companies: [{ text: "Seleccione", value: "" }]
    };
  },
  validations: {
    waybillData: {
      client_customer: { required },
      company: { required },
      number: { required, numeric },
      waybill_date: { required },
      // arrival_datetime: {required},
      truck_driver: { required },
      license_plate: { required },
      recipient: { required }
    }
  },
  methods: {
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.customers = customers;
          this.customers.unshift({ text: "Seleccione...", value: "" });
        })
        .catch((error) => console.log(error));
    },
    getCompanies(a) {
      this.companies = [{ value: "", text: "Cargando..." }];
      this.$axios
        .get("/api/comex/export_waybill/companies/")
        .then((res) => {
          const data = res.data;
          const companies = [];
          for (let key in data) {
            const company = data[key];
            companies.push(company);
          }
          this.companies = companies;
        })
        .catch((error) => console.log(error));
    },
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit("validate", false);
      } else {
        // do your submit logic here
        this.$emit("validate", true);
      }
    }
  },
  beforeMount() {
    this.getCustomers();
  }
};
</script>

<style scoped></style>
